import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { WindowRef } from "@obg/ngx.global";
import { map, switchMap } from "rxjs/operators";

import { SESSION_ACTION_TYPE } from "../auth/session.action";
import { Jurisdiction } from "../jurisdiction/jurisdiction.model";
import { MarketSelector } from "../market/market.selector";
import { CoreState } from "../state";

import { CustomerComplianceService } from "./customer-compliance.service";

@Injectable()
export class CustomerComplianceEffect {
	redaSgaCustomerCheck$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					SESSION_ACTION_TYPE.loginSuccess,
					SESSION_ACTION_TYPE.loginWithVerificationCodeSuccess,
					SESSION_ACTION_TYPE.loginWithPersonalNumberSuccess,
					SESSION_ACTION_TYPE.loginWithTokenSuccess,
					SESSION_ACTION_TYPE.loginWithCookieSuccess
				),
				switchMap(() => this.customerComplianceService.getCurrentCompliance$()),
				concatLatestFrom(() => this.store.select(this.marketSelector.getLanguageCode())),
				map(([compliance, languageCode]) => {
					if (compliance.jurisdiction === Jurisdiction.Reda && languageCode !== "de") {
						this.windowRef.native.location.reload();
					}
					return;
				})
			),
		{ dispatch: false }
	);

	constructor(
		private store: Store<CoreState>,
		private actions$: Actions,
		private customerComplianceService: CustomerComplianceService,
		private marketSelector: MarketSelector,
		private windowRef: WindowRef
	) {}
}
